import {
  SET_MAINTENANCE_REQUESTS_FILTER,
  SET_MAINTENANCE_REQUESTS_FILTER_CRITERIA,
  CLEAR_MAINTENANCE_REQUESTS_STATE,
  SET_CURRENT_MAINTENANCE_REQUEST
} from 'constants/reduceConstants';

const initialState = {
  filter: { responseReceived: false },
  filterCriteria: {},
  currentRequest: {}
};

const maintenanceRequestsReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case SET_MAINTENANCE_REQUESTS_FILTER:
      return { ...state, filter: payload };
    case SET_MAINTENANCE_REQUESTS_FILTER_CRITERIA:
      return { ...state, filterCriteria: payload };
    case SET_CURRENT_MAINTENANCE_REQUEST:
      return { ...state, currentRequest: payload };
    case CLEAR_MAINTENANCE_REQUESTS_STATE:
      return { ...initialState, filter: { ...state.filter, responseReceived: false } };
    default:
      return state;
  }
};

export default maintenanceRequestsReducer;
